import React from 'react';
import { StyledProgressBar, Step } from './styled';

const ProgressBar = ({
  totalSteps,
  stepNumber
}: {
  totalSteps: number;
  stepNumber: number;
}) => {
  return (
    <StyledProgressBar>
      {Array.from(Array(totalSteps).keys()).map((step) => (
        <Step key={step} $isPast={step < stepNumber} />
      ))}
    </StyledProgressBar>
  );
};

export default ProgressBar;
